/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trackStatisticsItemModelPagedResultSchema } from "./trackStatisticsItemModelPagedResultSchema.ts";
import { trackStatisticsItemModelSchema } from "./trackStatisticsItemModelSchema.ts";
import { z } from "zod";

export const tracksStatisticsModelSchema = z.object({
    "tracks": z.lazy(() => trackStatisticsItemModelPagedResultSchema).and(z.object({
    "items": z.array(z.lazy(() => trackStatisticsItemModelSchema))
    })).describe("Статистика по трекам").nullable().nullish(),
"totalListensCount": z.number().int().describe("Общее число прослушиваний по всем трекам"),
"totalListensCount50": z.number().int().describe("Число прослушиваний (когда прослушано более 50% трека)"),
"totalListensCount75": z.number().int().describe("Число прослушиваний (когда прослушано более 75% трека)"),
"totalListensCount95": z.number().int().describe("Число прослушиваний (когда прослушано более 95% трека)"),
"totalSharesCount": z.number().int().describe("Сколько раз делились треками"),
"totalSearchesCount": z.number().int().describe("Сколько раз треки запускали из поиска"),
"totalSwapsCount": z.number().int().describe("Сколько раз треки переключали"),
"totalLikesCount": z.number().int().describe("Сколько раз треки лайкали"),
"totalDislikesCount": z.number().int().describe("Сколько раз треки дизлайкали"),
"totalPlaylistsCount": z.number().int().describe("Сколько раз треки добавляли в плейлист")
    })